module.exports = __webpack_public_path__ + "static/media/excel_icon.ea2db8cd.png";